import React, { Component } from "react";
import "./ViewEdit.styles.scss";
// import { css } from "@emotion/core"
import BounceLoader from "react-spinners/BounceLoader";
import axios from "axios";
//import MomentUtils from "@date-io/moment";
import DateFnsUtils from "@date-io/date-fns";
// import moment from "moment"
import { format } from "date-fns";

import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";

// import fse_img from "./_image/person.svg"
import picture from "./_image/picture.svg";
import Dropdown from "./Dropdown/Dropdown";

const weekdays = [
  {
    id: "101",
    name: "Sunday",
  },
  {
    id: "102",
    name: "Monday",
  },
  {
    id: "103",
    name: "Tuesday",
  },
  {
    id: "104",
    name: "Wednesday",
  },
  {
    id: "105",
    name: "Thursday",
  },
  {
    id: "106",
    name: "Friday",
  },
  {
    id: "107",
    name: "Saturday",
  },
];

class ViewEdit extends Component {
  state = {
    image: this.props.data.image
      ? this.props.data.image
      : "https://png.pngitem.com/pimgs/s/506-5067022_sweet-shap-profile-placeholder-hd-png-download.png",
    image_object: null,

    loading: false,

    name: this.props.data.name,
    whitelisting_number: this.props.data.contact_number,

    reporting_manager: null,
    all_fse: [],
    selected_fse: [],

    leave_day: null,

    spot_codes: [],
    all_spot_codes: [],
    selected_spots: [],
    prev_spot_codes: [],

    showErr: false,
    joining_date: this.props.data.joining_date || new Date(),
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.reporting_manager !== this.state.reporting_manager) {
      this.loadSpotCodes(this.state.reporting_manager);
    }
  }

  componentDidMount() {
    this.loadFSE();
    // this.loadSpotCodes()
    this.setState({ selected_spots: this.props.data.spot_codes });

    if (this.props.data.leave_day[0] === "Sunday")
      this.setState({ leave_day_id: "101" });
    if (this.props.data.leave_day[0] === "Monday")
      this.setState({ leave_day_id: "102" });
    if (this.props.data.leave_day[0] === "Tuesday")
      this.setState({ leave_day_id: "103" });
    if (this.props.data.leave_day[0] === "Wednesday")
      this.setState({ leave_day_id: "104" });
    if (this.props.data.leave_day[0] === "Thursday")
      this.setState({ leave_day_id: "105" });
    if (this.props.data.leave_day[0] === "Friday")
      this.setState({ leave_day_id: "106" });
    if (this.props.data.leave_day[0] === "Saturday")
      this.setState({ leave_day_id: "107" });

    let prev_spot_codes = [];
    this.props.data.spot_codes.map((spot) => {
      return prev_spot_codes.push({ id: spot, name: spot });
    });
    this.setState({ prev_spot_codes });
  }

  loadFSE = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/admin_panel/v1/fse-list?include=all`,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
      .then((res) => {
        this.setState({ all_fse: res.data.data });
      });
  };
  loadSpotCodes = (fse) => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/admin_panel/v1/spot-codes${
          fse ? `?fse=${fse}` : ""
        }`,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
      .then((res) => {
        const formatted = res.data.data.map((code) => ({
          id: code.id,
          name: code.code,
        }));
        console.log(formatted);
        this.setState({
          all_spot_codes: formatted,
        });
      });
  };

  handleSelectSpots = (spots) => {
    let arra = [];
    spots.map((spot) => {
      return arra.push(spot.id);
    });
    spots.length === 0
      ? this.setState({ selected_spots: [] })
      : this.setState({ selected_spots: arra });
  };

  handleSelectLeave = (leave) => {
    this.setState({ leave_day: leave.name, leave_day_id: leave.id });
  };

  handleSelectFse = (fse) => {
    this.setState({ selected_fse: fse });
    let filter = typeof fse !== undefined ? fse.id : " ";

    this.setState({ reporting_manager: filter }, () => this.loadFSE());
  };

  handleClick = () => {
    document.getElementById("uploadeditimage").click();
  };

  handleImageChange = (event) => {
    const fileUploaded = event.target.files[0];
    this.setState({
      image: URL.createObjectURL(fileUploaded),
      image_object: fileUploaded,
    });
  };

  handleDateChange = (date) => {
    this.setState({
      joining_date: date,
    });
  };

  handleFormSubmit = () => {
    this.setState({ loading: true });
    const fd = new FormData();

    const {
      name,
      whitelisting_number,
      reporting_manager,
      leave_day,
      image_object,
      selected_spots,
      image,
      joining_date,
    } = this.state;

    if (
      name &&
      whitelisting_number &&
      reporting_manager &&
      leave_day &&
      joining_date &&
      (image_object || image)
    ) {
      if (image_object === null) {
        fd.append("image_url", image);
      } else {
        fd.append("image", image_object);
      }
      fd.append("name", name);
      fd.append("whitelisting_number", whitelisting_number);
      fd.append("reporting_manager", reporting_manager);
      fd.append("leave_day", leave_day);
      if (selected_spots.length > 0) {
        fd.append("spot_codes", selected_spots);
      } else {
        fd.append("spot_codes", this.props.data.spot_codes);
      }
      fd.append(
        "joining_date",
        format(new Date(joining_date), "yyyy-MM-dd")
        // moment(joining_date).format("yyyy-MM-dd").toString()
      );
      fd.append("id", this.props.data.id);

      axios
        .put(
          `${process.env.REACT_APP_API_URL}/api/admin_panel/v1/mdo-create`,
          fd,
          {
            headers: {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
            },
          }
        )
        .then((res) => {
          console.log(res);
          this.props.handleSave();
          setTimeout(() => {
            this.setState({
              loading: false,
              showErr: false,
            });
            this.props.viewMainOnClick();
          }, 2000);
        })
        .catch((err) => {
          this.setState({ loading: false, showErr: true });
          console.log(`error updating mdo ${err}`);
        });
    }

    console.log(this.state.selected_spots);
  };

  render() {
    console.log(this.state.prev_spot_codes);
    return (
      <>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <div className="edit-main">
            <div className="edit-body">
              <div className="basic">
                <div className="image">
                  <img src={this.state.image} alt="edit" />
                  <div className="tag" onClick={this.handleClick}>
                    <img src={picture} alt="upload" />
                    <input
                      type="file"
                      id="uploadeditimage"
                      onChange={this.handleImageChange}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
                <div className="instructions">
                  <p>
                    Upload a clear picture of the MDO. Picture must be a minimum
                    of 400x400 px and maximum of 1 mb.
                  </p>
                </div>
              </div>
            </div>

            <form>
              <div className="group">
                <input
                  onChange={(e) =>
                    this.setState({
                      name: e.target.value,
                    })
                  }
                  // placeholder={this.props.name}
                  defaultValue={this.props.data.name}
                  type="text"
                  required="required"
                />
                <span className="highlight"></span>
                <span className="bar"></span>
                <label>Full Name</label>
              </div>
              <div className="group">
                <input
                  onChange={(e) =>
                    this.setState({
                      whitelisting_number: e.target.value,
                    })
                  }
                  defaultValue={this.props.data.contact_number}
                  // placeholder={this.props.name}
                  type="text"
                  required="required"
                />
                <span className="highlight"></span>
                <span className="bar"></span>
                <label>Phone</label>
              </div>

              <Dropdown
                className="dd-cmdo"
                title="Select FSE"
                items={this.state.all_fse}
                default_value={{
                  id: this.props.data.fse_id,
                  name: this.props.data.fse,
                }}
                searchable
                onChange={this.handleSelectFse}
              />
              <Dropdown
                className="dd-cmdo"
                title="Leave Day"
                items={weekdays}
                searchable
                default_value={{
                  id: this.state.leave_day_id,
                  name: this.props.data.leave_day[0],
                }}
                onChange={this.handleSelectLeave}
              />
              <KeyboardDatePicker
                autoOk
                variant="inline"
                inputVariant="outlined"
                label="Joining Date"
                format="dd/MM/yyyy"
                value={this.state.joining_date}
                InputAdornmentProps={{ position: "start" }}
                onChange={(date) => this.handleDateChange(date)}
              />
              <Dropdown
                className="dd-cmdo"
                title="Select Spots"
                items={this.state.all_spot_codes}
                multiselect
                searchable
                spots
                default_value={this.state.prev_spot_codes}
                onChange={this.handleSelectSpots}
              />
              {this.state.prev_spot_codes.length > 0 && (
                <div className="prev-spots">
                  <p>Current Spots &nbsp;</p>
                  {this.state.prev_spot_codes.map((spot) => (
                    <span key={spot.id}>{spot.name} </span>
                  ))}
                </div>
              )}
            </form>

            <div className="footer-edit">
              <BounceLoader
                className="loader"
                color={"#e2136e"}
                size={20}
                loading={this.state.loading}
              />
              {this.state.showErr && (
                <div className="error-msg">
                  <span>
                    Something went wrong. Please re-select spot codes.
                  </span>
                </div>
              )}
              <button
                className="button--cancel"
                onClick={this.props.viewMainOnClick}
              >
                {" "}
                Cancel
              </button>
              <button className="button--save" onClick={this.handleFormSubmit}>
                {this.props.data.status === "Deactivated"
                  ? "Reactivate"
                  : "Save"}
              </button>
            </div>
          </div>
        </MuiPickersUtilsProvider>
      </>
    );
  }
}

export default ViewEdit;
